module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "tm54dvar-ch4flux-monthgrid-v1.thumbnails.microbial.abc53b23.png";